import authentication from "@/store/modules/authentication";
import pageMeta from "@/store/modules/pageMeta";
import organisations from "@/store/modules/organisations";
import branding from "./branding";

export default {
  authentication,
  pageMeta,
  organisations,
  branding,
};
